import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgAnxiousSelectedEmojiSecondary from './svgs/AnxiousSelectedEmojiSecondary.js';
import SvgAnxiousSelectedEmoji from './svgs/AnxiousSelectedEmoji.js';
import { useIcon } from '../../shared-components/icon/index.js';

var anxiousSelectedEmoji = (props => useIcon(SvgAnxiousSelectedEmoji, SvgAnxiousSelectedEmojiSecondary, props));

export { anxiousSelectedEmoji as default };
